module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueParcours_ScienceMd.38dfb409.png";